import { Injectable, InjectionToken, Inject, Optional } from '@angular/core';
export const FARRIS_FORM_COMPONENTS = new InjectionToken<{[key: string]: any}>('è¡¨åå¼¹åºçªå£æéèç»ä»¶åè¡¨');

/**
 * è¡¨åæå¡
 * @scope FormModule
 */
@Injectable()
export class FarrisFormService {

    private controls: { [key: string]: any} = {};

    constructor(@Optional()@Inject(FARRIS_FORM_COMPONENTS) initCtrls: any = {}) {
      if (!initCtrls) {
        initCtrls = {};
      }
      this.controls = { ...initCtrls };
    }

    append(key: string, cmpIns: any) {
        this.controls[key] = cmpIns;
    }

    getControls(key: string) {
        if (this.controls[key]) {
            return this.controls[key];
        } else {
            console.warn(`æªæ¾å°Keyä¸º${key}çç»ä»¶ï¼`);
            return null;
        }
    }

}
